import { render, staticRenderFns } from "./AddExistingBlockDialog.vue?vue&type=template&id=58f00edf&scoped=true"
import script from "./AddExistingBlockDialog.vue?vue&type=script&lang=js"
export * from "./AddExistingBlockDialog.vue?vue&type=script&lang=js"
import style0 from "./AddExistingBlockDialog.vue?vue&type=style&index=0&id=58f00edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f00edf",
  null
  
)

export default component.exports